import { AudioFragment, HubRichTextBackground } from '@/__generated__/graphql';
import React, { ReactElement } from 'react';
import { GridContainer } from '@theme/lib';
import Image from 'next/image';
import { imageLoaderResponsive } from '@theme/lib';
import Accordion from '../Accordion';
import { AudioGridContainer, AudioGridWrapper, StyledImage } from './Audio.styles';
import AudioWaveSurfer from './AudioWaveSurfer';
import { bicentenaryBackgroundClass } from '@components/BicentenaryPatterns/util';

interface ImageProps {
  img: {
    altText: string | null;
    url: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
}

function ImageComponent(data: ImageProps): ReactElement {
  return (
    <StyledImage>
      <Image
        src={data.img.url}
        alt={data.img.altText || ''}
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        width="906"
        height="545"
        loader={imageLoaderResponsive(906, 545)}
      />
    </StyledImage>
  );
}

export default function Audio(props: AudioFragment): ReactElement {
  const { field_audio, field_image, field_content, field_remove_spacing } = props;
  return (
    <AudioGridContainer className={`${props.__typename} ${bicentenaryBackgroundClass(props)}`} key={props.id} field_remove_spacing={field_remove_spacing ?? undefined}>
      <GridContainer>
        <AudioGridWrapper alignment={'centre'}>
          {field_image?.url && <ImageComponent img={field_image} />}
          {field_audio?.url && <AudioWaveSurfer id={field_audio.id} url={field_audio.url} />}
          {field_content?.processed && (
            <Accordion
              id={`${props.id}_accordion`}
              __typename={'AccordionParagraph'}
              alignment={'left'}
              tabs={[
                {
                  __typename: 'AccordionTabParagraph',
                  content: field_content,
                  id: `${props.id}_accordion-tab`,
                  title: 'See Transcription',
                  closeTitle: 'Close Transcription',
                  field_hub_rich_text_background: HubRichTextBackground.seagrass,
                },
              ]}
            />
          )}
        </AudioGridWrapper>
      </GridContainer>
    </AudioGridContainer>
  );
}
